import type { AlternativeFlightsData, MergedOfferItemData } from '@/interfaces/offer';
import { getPricing } from './priceUtils';
import { getBaseUrl } from './environmentUtils';

export type OfferBookingDetails = Pick<MergedOfferItemData, 'BookingURL' | 'Status'>;
export type AlternativeFlightsPriceDetails = Pick<AlternativeFlightsData, 'Pricing' | 'Price'>;

export function getBookingUrl(offer: OfferBookingDetails | null, alternativeFlight: AlternativeFlightsPriceDetails) {
	if (!offer || !offer.BookingURL) return '';
	if (offer.Status === 'CheckUnable' || offer.Status === 'Undefined') {
		const url = new URL(offer.BookingURL);
		const { amount: singlePrice, currency } = getPricing(alternativeFlight.Pricing, true);
		const additionalParams: Record<string, string> = {
			amount: singlePrice!.toString(),
			currency: 'EUR',
		};

		if (currency === 'CHF') {
			additionalParams.exchangeRateAmount = alternativeFlight.Price.Converted?.ExchangeRate.toString() ?? '';
			additionalParams.exchangeRateCurrency = currency;
		}

		Object.entries(additionalParams).forEach(([key, value]) => {
			url.searchParams.append(key, value);
		});

		return url.toString();
	}

	return offer.BookingURL;
}

export function appendQueryToUrl(url: string, query: Record<string, string | number | string[] | number[]>) {
	const newUrl = new URL(url, getBaseUrl());
	Object.entries(query).forEach(([key, value]) => {
		newUrl.searchParams.append(key, value.toString());
	});
	return newUrl.toString();
}

export function sanitizeBookingUrl(url: string) {
	let bookingUrl = url;
	const baseUrl = getBaseUrl();

	if (!bookingUrl.includes(baseUrl)) {
		bookingUrl = baseUrl + bookingUrl;
	}
	return bookingUrl;
}
